
<template>
    <div>
      <div class="columns">
          <div class="column has-text-centered">
              <div class="">
                <h1 class="is-size-3 has-text-white">
                    USER MANAGER
                </h1>
              </div>
          </div>
      </div>
      <div class="columns">
          <div class="column">
                <b-table :data="users" paginated :per-page="10" :current-page.sync="currentPage"
                    :pagination-simple="false" pagination-position="bottom" striped :loading="isLoading">
                    <b-table-column field="email" label="Email" width="40" v-slot="props">
                        <div v-if="!!props.row.email">
                            <p>{{props.row.email}}</p>
                        </div>
                        <div v-else> 
                            <p>No Email Regsitered</p>
                        </div>
                    </b-table-column>
                    <b-table-column field="first_name" label="First Name" width="40" v-slot="props">
                        {{ props.row.first_name }}
                    </b-table-column>
                    <b-table-column field="last_name" label="Last Name" width="40" v-slot="props">
                        {{ props.row.last_name }}
                    </b-table-column>
                    <b-table-column field="country" label="Country" width="40" v-slot="props">
                        {{ props.row.country }}
                    </b-table-column>
                </b-table>
          </div>
      </div>
  </div>
</template>

<script>
import { API  } from 'aws-amplify'
import { personReader } from '../graphql/queries'
export default {
    data(){
        return{
            users:[],
            currentPage: 1,
            isLoading: false
        }
    },
    methods:{
        async getUsers() {
            this.isLoading = true;
            try {
                const Users = await API.graphql({
                    query: personReader,
                    variables: {
                        input: {
                            request_type: 'read_all'
                        }
                    }
                });
                this.users = Users.data.personReader;
            } catch (e) {
                    this.$buefy.notification.open({
                    duration: 5000,
                    message: `${e}`,
                    position: 'is-bottom',
                    type: 'is-danger',
                    hasIcon: true
                })
            }
            this.isLoading = false
        },
    },
    beforeMount(){
        this.getUsers();
    }
}
</script>

<style>
</style>